module.exports = __webpack_public_path__ + "img/children-3.e8e5adc2.jpg";